import React from "react";
import { useSelector } from "react-redux";

import { ChangePassword } from "./ChangePassword";
import { changePassword } from "../../components/DataOperations";

export function ChangePasswordContainer() {
    const username = useSelector(state => state.user.username);
    const isAdviser = useSelector(state => Boolean(state.user.adviserId));

    return <ChangePassword submit={changePassword} username={username} isAdviser={isAdviser} />;
}
